export enum ColorType {
  black = 'black',
  blue = 'blue',
  brown = 'brown',
  gold = 'gold',
  gray = 'gray',
  green = 'green',
  orange = 'orange',
  purple = 'purple',
  red = 'red',
  silver = 'silver',
  white = 'white',
  yellow = 'yellow',
  other = 'other',
  unknown = 'unknown',
}

export const ColorTypeValues: { [key in ColorType]: string } = {
  black: 'Black',
  blue: 'Blue',
  brown: 'Brown',
  gold: 'Gold',
  gray: 'Gray',
  green: 'Green',
  orange: 'Orange',
  purple: 'Purple',
  red: 'Red',
  silver: 'Silver',
  white: 'White',
  yellow: 'Yellow',
  other: 'Other',
  unknown: 'Unknown',
};

export const fromColorTypeValue = (value: string) => {
  switch (value) {
    case 'Black':
      return ColorType.black;
    case 'Blue':
      return ColorType.blue;
    case 'Brown':
      return ColorType.brown;
    case 'Gold':
      return ColorType.gold;
    case 'Gray':
      return ColorType.gray;
    case 'Green':
      return ColorType.green;
    case 'Orange':
      return ColorType.orange;
    case 'Purple':
      return ColorType.purple;
    case 'Red':
      return ColorType.red;
    case 'Silver':
      return ColorType.silver;
    case 'White':
      return ColorType.white;
    case 'Yellow':
      return ColorType.yellow;
    case 'Other':
      return ColorType.other;
    case 'Unknown':
      return ColorType.unknown;
    default:
      throw new Error(`invalid ColorType value: ${value}`);
  }
};
